import {
  ArrowSquareOut as ArrowSquareOutIcon,
  DownloadSimple as DownloadIcon,
  X as XIcon,
} from "@phosphor-icons/react";

/** URLs of `GET …/fichiers/{id}/url`: `inlineUrl` displays, `url` downloads. */
export type PdfViewerFile = {
  url: string;
  inlineUrl: string;
};

export type PdfViewerProps = {
  file: PdfViewerFile;
  onClose: () => void;
};

export function PdfViewer({ file, onClose }: PdfViewerProps) {
  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-black/80">
      {/* Toolbar */}
      <div className="flex items-center justify-between bg-zinc-900 px-4 py-2">
        <div className="flex items-center gap-3">
          <a
            href={file.inlineUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 rounded px-2 py-1 text-sm text-zinc-300 hover:bg-zinc-800 hover:text-white"
          >
            <ArrowSquareOutIcon size={16} />
            Ouvrir dans un nouvel onglet
          </a>
          <a
            href={file.url}
            download
            className="flex items-center gap-1.5 rounded px-2 py-1 text-sm text-zinc-300 hover:bg-zinc-800 hover:text-white"
          >
            <DownloadIcon size={16} />
            Télécharger
          </a>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="rounded p-1 text-zinc-400 hover:bg-zinc-800 hover:text-white"
        >
          <XIcon size={20} />
        </button>
      </div>

      {/* PDF iframe */}
      <div className="flex-1">
        <iframe
          src={file.inlineUrl}
          className="h-full w-full border-0"
          title="Visionneuse PDF"
        />
      </div>
    </div>
  );
}
